import {
    Component,
    OnInit,
    Input,
    ViewEncapsulation,
    HostBinding,
    HostListener
} from '@angular/core';
import {
    Router,
    NavigationEnd
} from '@angular/router';

import { filter, tap } from 'rxjs/operators';

@Component({
    selector: 'app-market-resource',
    templateUrl: './resource.component.pug',
    styleUrls: ['./resource.component.less'],
    encapsulation: ViewEncapsulation.None
})
export class ResourceComponent implements OnInit {

    @HostBinding('style.color') styleColor;
    @HostBinding('class.btn--striped') isLoading: boolean;

    @Input() shard = null;
    @Input() color = null;
    @Input() data: any = {};
    @Input() resource = '';

    @HostListener('click')
    onClick(): void {
        this.isLoading = true;

        const navigationEnd$ = this._router.events
            .pipe(filter(e => e instanceof NavigationEnd))
            .pipe(tap((data) => this.isLoading = false))
            .subscribe(() => navigationEnd$.unsubscribe());
    }

    get hasPrice() {
        return this.data.hasOwnProperty('avgPrice');
    }

    get noData() {
        return !this.data.count;
    }

    constructor(
        private _router: Router
    ) {
    }

    ngOnInit() {
        this.styleColor = this.data.color;
    }

}
